module.exports = __webpack_public_path__ + "86be3727131773b8e30a1b61c1a7460e.svg";